import { Clipboard } from '@angular/cdk/clipboard';
import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, HostListener, Inject, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { FeedbackService } from '@services/feedback';

import { I18nService } from '../../i18n/services';

@Directive({
	selector: '[appCopyToClipboard]'
})
export class CopyToClipboardDirective implements OnChanges {
	@Input('appCopyToClipboard') content: string;
	@Input('appCopyToClipboardMsg') msg = this.i18nService.get('Copied to clipboard', 'app.action.copied-to-clipboard');
	@Input('appCopyToClipboardClose') close = 'x';
	@Input('appCopyToClipboardIcon') icon = false;
	// Hide approach of icon if enabled. Hide will maintain the space of the icon to prevent shifting of element length while none
	// will remove it from layout. Useful when you wanna control the spacing of the icon.
	@Input('appCopyToClipboardVisibility') visibility: 'hide' | 'none' = 'hide';

	@HostListener('click') onClick() {
		this.copyToClipboard(this.content);
	}

	@HostListener('mouseover') onMouseOver() {
		this.showIcon();
	}

	@HostListener('mouseout') onMouseOut() {
		this.hideIcon();
	}

	constructor(
		private elRef: ElementRef,
		private renderer: Renderer2,
		private clipboard: Clipboard,
		private feedbackService: FeedbackService,
		private i18nService: I18nService,
		@Inject(DOCUMENT) private document: Document
	) {}

	public ngOnChanges(): void {
		// Delay to next digest cycle to ensure content has rendered inside host component correctly before accessing it
		setTimeout(() => {
			if (this.icon && !this.elRef.nativeElement.innerHTML.includes('js-copy-icon')) {
				const child = this.document.createElement('span');
				child.innerHTML = `<span class="js-copy-icon material-icons" style="padding-left: 5px; pointer-events: none; font-size: inherit !important; width: inherit !important; height: inherit !important; vertical-align: middle;">content_copy</span>`;

				this.renderer.appendChild(this.elRef.nativeElement, child);
				this.hideIcon();
			}
		});

		if (!this.icon && this.elRef.nativeElement.querySelector('.js-copy-icon')) {
			this.hideIcon();
		}
	}

	private hideIcon(): void {
		const icon = this.elRef.nativeElement.querySelector('.js-copy-icon');

		if (!icon) return;

		if (this.visibility === 'none') {
			this.elRef.nativeElement.querySelector('.js-copy-icon').style.display = 'none';
		} else {
			this.elRef.nativeElement.querySelector('.js-copy-icon').style.visibility = 'hidden';
		}
	}

	private showIcon(): void {
		const icon = this.elRef.nativeElement.querySelector('.js-copy-icon');

		if (!icon) return;

		if (this.visibility === 'none') {
			this.elRef.nativeElement.querySelector('.js-copy-icon').style.display = 'inline-block';
		} else {
			this.elRef.nativeElement.querySelector('.js-copy-icon').style.visibility = 'visible';
		}
	}

	private copyToClipboard(value: string) {
		this.clipboard.copy(value);
		this.feedbackService.notification({ msg: this.msg });
	}
}
